import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicyDetails = () => {
  return (
    <>
      <section className='support-content ptb-120'>
        <div className='container'>
          <div className='row justify-content-between'>
            <div className='col-lg-12 col-md-8 p-lg-5'>
              <div className='support-article-wrap text-center'>
                <h1 className='display-5 mb-4 fw-bold'>
                  Privacy Policy
                </h1>

                <div className='job-details-info my-5'>
                  <h3 className='h5'>
                    Our policy on collection, use and security of information
                  </h3>
                  <ul className='list-unstyled'>
                    <li>
                      We are committed to complying with the current legislations and practices, concerning the rights of various individuals.
                    </li>
                  </ul>
                </div>
              </div>
              <div className='support-article-wrap'>
                  <h4 className='h5 padding-top-5 padding-bottom-4'>
                    1. INTRODUCTION
                  </h4>
                  <p>
                    Sunlex is a trusted and experienced provider of payment services and solutions across the globe.
                    The group includes Sunlex ltd. and its direct and indirect subsidiaries and other related undertakings.
                  </p>
                  <p>
                    Sunlex ltd. is an electronic money institution (Company No. 204749821) regulated and supervised by the Financial Conduct
                    Authority with principal place of business at 29, Howard Street, North Shields, Tyne and Wear, NE30 1AR, United Kingdom.
                  </p>
                  <p>
                    Sunlex ltd. is registered as a Data Controller with the Information Commissioner’s Officer under the
                    Data Protection Act 1998 and is subject to the provisions of the General Data Protection Regulation (GDPR).
                    This Policy Statement is designed to help the group and its employees to comply with the new EU regulation.
                  </p>
                  <p>
                    Sunlex Group regards the fair and lawful treatment of personal information as a critical factor in the
                    success of its operations and as a key to the maintenance of the confidence that exists between those
                    with whom we deal and ourselves. Sunlex Group therefore acknowledges its legal obligations under the new EU regulations and endorses its requirements.
                  </p>
                  <p>
                    Hereafter in this document, Sunlex Group will be referred to as Sunlex.
                  </p>
              </div>
              <div className='support-article-wrap'>
                <h4 className='h5 padding-top-10 padding-bottom-4'>
                  2. PURPOSE
                </h4>
                <p>
                  The purpose of this Policy Statement is to ensure that all employees of Sunlex and all others given use of, or having access to, personal information are fully aware of and abide by their duties and responsibilities under the GDPR and compliant with data protection procedures.
                </p>
              </div>
              <div className='support-article-wrap'>
                  <h4 className='h5 padding-top-10 padding-bottom-4'>
                    3. POLICY SCOPE
                  </h4>
                  <p>
                    This Policy Statement applies to any and all data that Sunlex collects and processes relating to identifiable living individuals in order to operate efficiently and carry out its services and may include, but is not limited to: names of individuals, postal addresses, email addresses, mobile phone numbers, etc.
                  </p>
                </div>
              <div className='support-article-wrap'>
                    <h4 className='h5 padding-top-10 padding-bottom-4'>
                      4. GUIDING PRINCIPLES
                    </h4>
                    <p>
                      Sunlex Group is committed to ensuring that in its businesses activities the organisation complies with the letter and the spirit of the law concerning the fundamental rights and freedoms of individuals whose personal information is being processed.
                    </p>
                    <p>
                      In particular, Sunlex is committed to ensuring that:
                    </p>
                    <ul className='content-list list-unstyled'>
                        <li>
                           the GDPR requirements are properly implemented through the establishment of internal policies and procedures;
                        </li>
                        <li>
                           Data Protection Officer (DPO) is appointed and the latter operates independently as a first point of contact for the supervisory authority and data subjects, but also internally within the organisation;
                        </li>
                        <li>
                           staff are trained and made aware of the law and their obligations under it, including the obligation to report internally certain types of data breach to the designated Data Protection Officer;
                        </li>
                        <li>
                           personal data is being collected and processed fairly and lawfully and only to the extent that it is needed to fulfil operational functions or to comply with any legal requirements;
                        </li>
                        <li>
                           highest security standards are addressed and implemented;
                        </li>
                        <li>
                           appropriate safeguards are provided and personal information is protected against accidental loss, alternation, unauthorised disclosure or access.
                        </li>
                      </ul>
              </div>
              <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        5. DATA PROTECTION COMPLIANCE FRAMEWORK
                      </h4>
                      <p>
                        To facilitate compliance with the GDPR requirements, Sunlex has developed and implemented a robust and transparent data protection compliance framework consisting of policies, procedures, internal controls and systems.
                      </p>
                      <p>
                        Data protection compliance framework includes provisions governing:
                      </p>
                      <ul className='content-list list-unstyled'>
                          <li>
                             promotion of enhanced compliance culture throughout the group;
                          </li>
                          <li>
                            implementation of data protection policies and procedures;
                          </li>
                          <li>
                             appointment of internal control functions (DPO, Compliance, Internal Audit);
                          </li>
                          <li>
                             implementation of internal control mechanisms for conducting regular risk assessments to identify threats and vulnerabilities that can affect data assets;
                          </li>
                          <li>
                             keeping up to date the electronic records of the processing activities and the security in operation at the time;
                          </li>
                          <li>
                             implementation of internal control systems for keeping personal information secure and protected from unauthorised processing, loss or destruction;
                          </li>
                          <li>
                             reporting of both confirmed and suspected incidents to the designated DPO;
                          </li>
                          <li>
                             queries about handling personal data are promptly and courteously dealt with.
                          </li>
                        </ul>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        6. DATA PROTECTION OFFICER
                      </h4>
                      <p>
                        Sunlex has appointed Data Protection Officer (DPO) with specific responsibilities for data protection.
                      </p>
                </div>
                <div className='support-article-wrap'>
                      <h4 className='h5 padding-top-10 padding-bottom-4'>
                        7. FURTHER INFORMATION
                      </h4>
                      <p>
                        If you wish to access or correct or delete any of your personal information as held by us, or if you have any questions or require further information regarding this Policy Statement, please contact our DPO at dpo@sunlex.net.
                      </p>
                      <p>
                        The Legal and Compliance Department will review its procedures regularly to ensure continued compliance with this Policy Statement. For a copy of the full privacy policy please click here.
                      </p>
                </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicyDetails;
